import { useSelector } from 'react-redux';
import { Suspense } from 'react';
import Thunderbite from '~/components/thunderbite/thunderbite-async.js';
import Splashtech from '../splashtech/splashtech-async';
import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';
import { selectThunderbiteEnabled, selectIsSplashtechEnabled } from '~/components/brand/ducks/selectors.js';
import { selectEnableFreeToPlay } from '../brand/ducks';

const MainModal = () => {
	const freeToPlayEnabled = useSelector(selectEnableFreeToPlay);
	const authenticated = useSelector(authenticationSelector);
	const isThunderbiteEnabled = useSelector(selectThunderbiteEnabled);
	const isSplashtechEnabled = useSelector(selectIsSplashtechEnabled);

	if (!authenticated) return null;

	return (
		<Suspense fallback={<div className="spinner" />}>
			{!freeToPlayEnabled && isThunderbiteEnabled && <Thunderbite />}
			{!freeToPlayEnabled && isSplashtechEnabled && <Splashtech />}
		</Suspense>
	);
};

export default MainModal;
